import React, { useEffect, useState } from "react";
import { useAppContext } from "../../context";
import Translator from "../i18n/Translator";
import "./Brochures.scss";
import { FaDownload, FaChevronDown, FaChevronUp } from "react-icons/fa";

const Brochures = () => {
  const { fetchBrochures, brochures, language } = useAppContext();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    fetchBrochures();
  }, []);
  console.log(language);
  return (
    <div className='brochures'>
      <button onClick={() => setOpen(!open)} className='brochures__title'>
        {<Translator path='DigitalBrochures' />}
        {!open ? <FaChevronDown /> : <FaChevronUp />}
      </button>
      <span onClick={() => setOpen(!open)} className='brochures__title--desktop'>
        {<Translator path='DigitalBrochures' />}
        {!open ? <FaChevronDown /> : <FaChevronUp />}
      </span>
      {open && (
        <ul className='brochures__list'>
          {brochures.map((b) => (
            <li>
              <a className='brochures__link' href={b[`file${language}`].fields.file.url} download target='_blank'>
                {b[`label${language}`]}
                <FaDownload size='10' />
              </a>
            </li>
          ))}
        </ul>
      )}
      <ul className='brochures__list--desktop'>
        {brochures.map((b) => (
          <li>
            <a className='brochures__link' href={b[`file${language}`].fields.file.url} download target='_blank'>
              {b[`label${language}`]}
              <FaDownload size='10' />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Brochures;
